import { cloneElement, type MouseEvent, type ReactElement, useState } from "react";
import { ConfirmationModal, ConfirmationModalProps } from "./ConfirmationModal";

type ClickableElement = ReactElement<{ onClick?: (e: MouseEvent) => void }>;

type ConfirmationModalClickWrapperProps = ConfirmationModalProps & {
	children: ClickableElement;
	shouldConfirm?: boolean;
};

export const ConfirmationModalClickWrapper = ({
	children,
	shouldConfirm,
	onConfirm,
	onCancel,
	...props
}: ConfirmationModalClickWrapperProps) => {
	const [open, setOpen] = useState<boolean>(false);

	const handleCancel = () => {
		onCancel && onCancel();
		setOpen(false);
	};

	const handleConfirm = () => {
		onConfirm && onConfirm();
		setOpen(false);
	};

	return (
		<>
			{cloneElement(children, {
				onClick: (e: MouseEvent) => {
					if (shouldConfirm !== false) setOpen(true);
					else children.props.onClick?.(e);
				},
			})}
			{open && <ConfirmationModal {...props} onConfirm={handleConfirm} onCancel={handleCancel} />}
		</>
	);
};
